import { t } from '@lingui/core/macro';
import { GenericPartTypes, PartLite, PartLiteTypes } from '@luminovo/api-contracts';
import { isPresent } from '@luminovo/commons';

export function extractManufacturer(part: PartLite | undefined | null): { id: string; name: string } {
    if (!isPresent(part)) {
        return { id: 'unknown', name: t`Unknown` };
    }

    switch (part.kind) {
        case PartLiteTypes.OffTheShelf:
            return part.manufacturer;

        case PartLiteTypes.Generic:
            switch (part.content.type) {
                case GenericPartTypes.Capacitor:
                    return { id: 'generic-capacitor', name: t`Generic Capacitor` };
                case GenericPartTypes.Resistor:
                    return { id: 'generic-resistor', name: t`Generic Resistor` };
                default:
                    return { id: 'generic-unknown', name: t`Generic Unknown` };
            }
        case PartLiteTypes.RawSpecification:
            if (isPresent(part.manufacturer.id) && isPresent(part.manufacturer.name)) {
                return { id: part.manufacturer.id, name: part.manufacturer.name };
            }
            if (isPresent(part.manufacturer.name)) {
                return { id: `unknown-${part.manufacturer.name}`, name: part.manufacturer.name };
            }
            return { id: 'unknown', name: t`Unknown` };
        case PartLiteTypes.Ipn:
            return { id: 'ipn', name: t`IPNs` };
        case PartLiteTypes.Custom:
            return { id: `custom-${part.category.id}`, name: part.category.category };
        case PartLiteTypes.CustomComponent:
            return { id: 'custom-component', name: t`Custom Component` };
        case PartLiteTypes.Unknown:
            return { id: 'unknown', name: t`Unknown` };
        default:
            return { id: 'unknown', name: t`Unknown` };
    }
}
